import { Element } from "react-scroll";
import CompanyBasicSection from 'components/company/companybasicsection';
import Investorsection from 'components/company/investorsection';
import CompanyAboutSection from 'components/company/companyAboutSection';
import Peersection from 'components/company/peersection';
import QuarterResultSection from 'components/company/quarterresultsection';
import RatioSection from 'components/company/ratiosection';
import BalancesheetSection from 'components/company/balancesheetsection'; 
import CashFlowSection from 'components/company/cashflowsection';
import ProfitNLossSection from 'components/company/profitNlosssection';
import StockChartSection from 'components/company/stockchartsection';
import Forumsection from 'components/company/forumsection';
import AnalysisSection from 'components/company/analysissection';
import CompanyNews from '../../pages/news/CompanyNews'
import CompanyFAQ from 'components/company/company-faq'

export default function CompanySections({companysectionlist,companyinfo,type,companymainLabelsList,isFollowed}) {
  console.log("company basic data ",companyinfo);
  return (
    <div className="space-y-10 p-5">
  {companysectionlist.map((val) => (
    <Element key={val.id} name={val.id} id={val.id}>
      {val.id === "section1" ? (
        <CompanyBasicSection companyinfo={companyinfo} companymainLabelsList={companymainLabelsList} isFollowed={isFollowed} />
      ) 
       : val.id === "section2" ? (
        <StockChartSection companyinfo={companyinfo} />
      ) 
      : val.id === "section3" ? (
        <AnalysisSection companyinfo={companyinfo} />
      ) 
      : val.id === "section10" ? (
        <Investorsection companyinfo={companyinfo} />
      ) : 
       val.id === "section4" ? (
        <Peersection companyinfo={companyinfo} />
      ) 
      : 
       val.id === "section5" ? (
        <QuarterResultSection companyinfo={companyinfo} type={type} />
      ) 
      : 
       val.id === "section7" ? (
        <BalancesheetSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "section6" ? (
        <ProfitNLossSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "section8" ? (
        <CashFlowSection companyinfo={companyinfo} type={type} />
      ) 
       : 
       val.id === "section9" ? (
        <RatioSection companyinfo={companyinfo} type={type} />
      ) 
       : 
       val.id === "section11" ? (
        <Forumsection companyinfo={companyinfo} />     
      ) 
      :
      val.id === "section13" ? (
        <CompanyNews tag={companyinfo.symbol} />     
      )
      : 
       (<section className="bg-white shadow-md z-50 rounded-xl p-5">
          <h1 className="text-3xl font-bold">{val.label}</h1>
          <p className="mt-4">Check back soon.</p>
        </section>
      )}
    </Element>
  ))}

 <CompanyFAQ companyinfo={companyinfo} type={type} />
</div>
  );
}
